const CLEANER_VALUES = [null, undefined, ''];

export const clearObject = (_object: any, _CLEANER_VALUES = CLEANER_VALUES) => {
  const cleanedObj = { ..._object };
  Object.keys(cleanedObj).forEach((key) => {
    if (_CLEANER_VALUES.includes(cleanedObj[key])) {
      delete cleanedObj[key];
    }
  });

  return cleanedObj;
};

export const objectToKeyValueArray = (object: any) => {
  const array: { key: string; value: string }[] = [];
  Object.entries(object).map((item) => {
    if (item[1]) {
      array.push({ key: item[0], value: item[1] as string });
    }
    return false;
  });

  return array;
};

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
export const diffObjects = (obj1: any, obj2: any) => {
  // Make sure an object to compare is provided
  if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
    return obj1;
  }

  //
  // Variables
  //

  const diffs: {
    [key: string]: any;
  } = {};

  //
  // Methods
  //

  /**
   *
   * @param arr1
   * @param arr2
   */
  const arraysMatch = (arr1: [], arr2: []) => {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    // Otherwise, return true
    return true;
  };

  /**
   *
   * @param item1
   * @param item2
   * @param key
   */
  const compare = (item1: any, item2: any, key: string) => {
    // Get the object type
    const type1 = Object.prototype.toString.call(item1);
    const type2 = Object.prototype.toString.call(item2);

    // If type2 is undefined it has been removed
    if (type2 === '[object Undefined]') {
      diffs[key] = null;
      return;
    }

    // If items are different types
    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    // If an object, compare recursively
    if (type1 === '[object Object]') {
      const objDiff = diffObjects(item1, item2);
      if (Object.keys(objDiff).length > 0) {
        diffs[key] = objDiff;
      }
      return;
    }

    // If an array, compare
    if (type1 === '[object Array]') {
      if (!arraysMatch(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    // Else if it's a function, convert to a string and compare
    // Otherwise, just compare
    if (type1 === '[object Function]') {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else if (item1 !== item2) {
      diffs[key] = item2;
    }
  };

  //
  // Compare our objects
  //

  // Loop through the first object
  Object.keys(obj1).map((key) => {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      compare(obj1[key], obj2[key], key);
    }
    return false;
  });

  // Loop through the second object and find missing items
  Object.keys(obj2).map((key) => {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (!obj1[key] && obj1[key] !== obj2[key]) {
        diffs[key] = obj2[key];
      }
    }
    return false;
  });

  // Return the object of differences
  return diffs;
};

export const isObjectEmpty = (object: any) => Object.keys(object).length === 0;

export const stringToBoolean = (str: string) => str.toLowerCase() === 'true';
